import React from 'react'
import useInput from 'tennders-common/form/hooks/useInput'
import stylesInput from '@/styles/Input.module.scss'

type Props = {
  className?: string,
  labelClassName?: string,
  label?: string,
  errors?: Record<string, any>,
  form ?: Record<string, any>,
  name?: string,
  onChange?: (key: string, value: any) => void,
  required?: boolean,
  disabled?: boolean,
  renderInput?: (any) => JSX.Element
}

const FieldsetContainer = (props: Props) => {
  const {
    className = '',
    labelClassName = 'form-label',
    label = '',
    errors,
    form,
    name,
    onChange,
    disabled,
    required,
    renderInput
  } = props

  const { errorContent, onSet, errorText, value } = useInput({
    errors,
    form,
    name,
    onChange
  })

  return (
    <fieldset className={className}>
      {(label || errorContent) && (
        <label className={labelClassName}>
          {' '}
          {label}
          {required && <span className={stylesInput.required}>*</span>}
          {errorContent}
        </label>
      )}
      {renderInput({ form, error: errorText as never, name, onSet, value, disabled, required })}
    </fieldset>
  )
}

export default React.memo<Props>(FieldsetContainer)
